
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";

@Component({
  components: {},
  filters,
})
export default class Loading extends Vue {}
